import { useCallback } from 'react'
import { COMPETITIONS_BOTTOM_BAR_CONFIG } from '../../config/competitionsBottomBarConfig'
import { useBrowerStorage } from '../useBrowserStorage'

const EMPTY_ARRAY = []

export const useClearUserCompetitionCache = (): { clearUserCompetitionCache: () => void } => {
    const { setValue: setCachedUserCompetitions } = useBrowerStorage({
        key: COMPETITIONS_BOTTOM_BAR_CONFIG.USER_COMPS.LOCAL_STORAGE_KEY,
        defaultValue: EMPTY_ARRAY,
    })

    const { setValue: setUserCompetitionsCacheExpiration } = useBrowerStorage({
        key: COMPETITIONS_BOTTOM_BAR_CONFIG.USER_COMPS.EXPIRATION.LOCAL_STORAGE_KEY,
        defaultValue: '',
    })

    const clearUserCompetitionCache = useCallback(() => {
        setCachedUserCompetitions(EMPTY_ARRAY)
        setUserCompetitionsCacheExpiration('')
    }, [setCachedUserCompetitions, setUserCompetitionsCacheExpiration])

    return { clearUserCompetitionCache }
}
